import React from "react";
import Header from "../header/MainHeader";

class NsuRegistration extends React.Component {
    componentDidMount() {
        // Client-side redirect as fallback
        window.location.href = "https://www.empirio.ai/de-DE/auth";
    }

    render() {
        return (
            <main>
                <Header />
                <section className="page-title-section theme-bg">
                    <div className="container-fluid">
                        <div className="row align-items-center justify-content-center no-gutters text-center min-height-form">
                            <div className="registration-form col-12 col-sm-10 col-md-7 col-lg-5">
                                <div className="padding-login-form hs-form-field">
                                    <h2 className="text-dark font-weight-bold mb-4">Du wirst weitergeleitet...</h2>
                                    <p className="text-gray">
                                        Du wirst in Kürze zur neuen Registrierungsseite weitergeleitet.
                                    </p>
                                    <p className="mt-4">
                                        <a href="https://www.empirio.ai/de-DE/auth" className="btn btn-clr text-white">
                                            Jetzt weiter
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        );
    }
}

export default NsuRegistration;
